// extracted by mini-css-extract-plugin
export default {"rawId":"_1si3gFMMe4kvkmILbX4bXI"};